<div class="contact-informations__item">
  <span class="contact-informations__item-title">{{ title }}</span>
  <div class="contact-informations__item-content">
    <ng-content></ng-content>
  </div>
</div>
